"use client"
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";

import "@/components/shared/UralityBrandedModal.css";

const UralityBrandedModal = ({ show, size, fullscreen, onHide, children }) => {
  return (
    <Modal
      className={"urality-branded-modal"}
      show={show}
      size={size}
      fullscreen={fullscreen}
      onHide={onHide}
      centered
    >
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <div className="navbar light d-flex align-items-center w-100 flex-row justify-content-center gap-2">
          <a
            href="https://urality.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Powered by</span>
          </a>
          <a
            href="https://urality.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="logo-horizontal sm" />
          </a>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default UralityBrandedModal;
